// extracted by mini-css-extract-plugin
export var printerCard = "_bz-1";
export var printerCardConfigured = "_bz-2";
export var printerCardError = "_bz-3";
export var printerCardsContainer = "_bz-0";
export var printerIcon = "_bz-8";
export var printerIconConfigured = "_bz-5";
export var printerIconContainer = "_bz-4";
export var printerIconError = "_bz-6";
export var printerIconUnconfigured = "_bz-7";
export var workstationsTableCard = "_bz-9";